import React, { memo } from 'react';
import { IconWrapper } from 'src/modules/common/icons/IconWrapper';

type Props = {
  readonly className?: string;
};

export const LoadingSpinner = memo(
  ({ className }: Props): React.ReactElement => (
    <div className={className}>
      <IconWrapper>
        <svg
          viewBox="0 0 24 24"
          fill="none"
        >
          <circle
            fill="none"
            stroke="currentColor"
            cx="50%"
            cy="50%"
            r="10"
          />
        </svg>
      </IconWrapper>
    </div>
  ),
);
